import { FC, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Box from '../../../components/fela/Box';
import { IStylingProps } from '../../../themes/types';
import componentStyles from './index.style';
import SnackbarContent, { ISnackbarOptions } from './snackbar-content';

interface Props extends ISnackbarOptions, IStylingProps {
  dataTest?: string;
  offset?: number;
}

export const Snackbar: FC<Props> = ({
  mode,
  uuid,
  text,
  linesLimit,
  show = false,
  timeout,
  onTimeout,
  offset = 32,
  icon,
  ctaContent,
}) => {
  const styles = componentStyles();
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalTarget(document.body);
    return () => setPortalTarget(null);
  }, []);

  if (!show || !portalTarget) return null;

  return createPortal(
    <Box style={styles.snackbarWrapper(show, offset)} data-name="snackbar">
      <SnackbarContent
        {...{ mode, text, show, icon, ctaContent, timeout, onTimeout, uuid, linesLimit }}
      />
    </Box>,
    portalTarget,
  );
};
